import { IconButton, styled } from '@/core/ui';
export const IconButtonStyled = styled(IconButton)(({ theme }) => ({
    ':hover': {
        color: theme.palette.primary.dark,
    },
}));
export const PopoverContent = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    maxWidth: 400,
    padding: theme.spacing(4),
    color: theme.palette.text.secondary,
}));
export const HotkeysTitle = styled('div')(({ theme }) => ({
    fontSize: theme.typography.h6.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.text.primary,
}));
export const HotkeysList = styled('ul')(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: 'auto auto',
    columnGap: theme.spacing(12),
    rowGap: theme.spacing(1),
    margin: 0,
    padding: 0,
    listStyle: 'none',
    '> li': {
        display: 'contents',
    },
}));
export const HotkeysNote = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    fontSize: theme.typography.caption.fontSize,
    lineHeight: '1.25rem',
    color: theme.palette.text.muted,
    '> p': {
        margin: 0,
    },
}));
export const HotkeyText = styled('span')(({ theme }) => ({
    justifySelf: 'end',
    fontWeight: theme.typography.fontWeightBold,
    whiteSpace: 'nowrap',
}));
